import React from 'react'

export default class Usuarios extends React.Component{
	render(){
		return( 
			<i className={this.props.classSrc} style={{marginRight: "15px"}}></i>
		)
	}
}